import { Alert } from '@mui/material'

interface ErrorAlertProps {
  name: string
  formik: any
}

export const ErrorAlert = ({ formik, name }: ErrorAlertProps): JSX.Element => {
  return (
    <>
      {formik.touched[name] !== undefined &&
        formik.errors[name] !== undefined && (
          <Alert severity='error'>{formik.errors[name]}</Alert>
      )}
    </>
  )
}
